module.exports = __webpack_public_path__ + "img/login-page-logo.8756719a.svg";